import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import _ from "lodash";
import { IGetArbetsorderRequest } from "~app/features/planera/model/IGetArbetsorderRequest";
import { SkotningAvstandFilter } from "~app/features/planera/model/SkotningAvstandFilter";
import { ArbetsorderSearchBase } from "../../../models/arbetsorder-search-base";

@Component({
    selector: "rask-arbetsorder-search-skoglig-data-skotning-avstand",
    templateUrl: "./arbetsorder-search-skoglig-data-skotning-avstand.component.html",
    styleUrls: ["./arbetsorder-search-skoglig-data-skotning-avstand.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBase,
            useExisting: forwardRef(() => ArbetsorderSearchSkogligDataSkotningAvstandComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputNumberComponent,
        FormsModule
    ]
})
export class ArbetsorderSearchSkogligDataSkotningAvstandComponent extends ArbetsorderSearchBase implements OnInit {
    @Input() searchFilter: IGetArbetsorderRequest;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.applyFilter();
    }

    forceUpdateFilterChange(): void {
        this.applyFilter();
    }

    get skotningAvstandMax() {
        return (this.isset(this.searchFilter.skogligdata.skotningAvstand?.max)) ? this.searchFilter.skogligdata.skotningAvstand.max : null;
    }

    set skotningAvstandMax(value) {
        if (value && (!this.searchFilter.skogligdata.skotningAvstand.min)) {
            this.searchFilter.skogligdata.skotningAvstand.min = 1;
        }
        this.searchFilter.skogligdata.skotningAvstand.max = value;
    }

    get skotningAvstandMaxMinRule() {
        return (this.searchFilter.skogligdata.skotningAvstand?.min) ? this.searchFilter.skogligdata.skotningAvstand.min : 1;
    }

    get skotningAvstandMin() {
        return (this.isset(this.searchFilter.skogligdata.skotningAvstand?.min)) ? this.searchFilter.skogligdata.skotningAvstand.min : null;
    }

    set skotningAvstandMin(value) {
        if (value && this.searchFilter.skogligdata.skotningAvstand.max < value) {
            this.searchFilter.skogligdata.skotningAvstand.max = null;
        }
        this.searchFilter.skogligdata.skotningAvstand.min = value;
    }

    private applyFilter() {
        if(_.isNil(this.searchFilter.skogligdata.skotningAvstand)) {
            this.searchFilter.skogligdata.skotningAvstand = new SkotningAvstandFilter();
        }
    }

    private isset(value: any): boolean {
        return !_.isNil(value);
    }
}
